import { Typography } from "@mui/material";
import { FC } from "react";
import { Asset } from "./server/digital-asset-service";

export const AssetCount: FC<{ assets: Asset[] }> = ({ assets }) => {
  return <Typography variant="h6">{assets.length} assets</Typography>;
};
